import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AdminSitemapRoutingModule } from './admin-sitemap-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AdminSitemapRoutingModule
  ]
})
export class AdminSitemapModule { }
